var _path, _path2, _path3;
const _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgIcontimemanager = _ref => {
  let {
      svgRef
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00008 14.8333C4.69084 14.8333 2.00008 12.1426 2.00008 8.83333C2.00008 5.5241 4.69084 2.83333 8.00008 2.83333C11.3093 2.83333 14.0001 5.5241 14.0001 8.83333C14.0001 12.1426 11.3093 14.8333 8.00008 14.8333ZM8.00008 3.16667C4.87599 3.16667 2.33341 5.70924 2.33341 8.83333C2.33341 11.9574 4.87599 14.5 8.00008 14.5C11.1242 14.5 13.6667 11.9574 13.6667 8.83333C13.6667 5.70924 11.1242 3.16667 8.00008 3.16667Z",
    fill: "#757575",
    stroke: "#757575",
    strokeWidth: 0.666667
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 9.16668C7.72667 9.16668 7.5 8.94001 7.5 8.66668V5.33334C7.5 5.06001 7.72667 4.83334 8 4.83334C8.27333 4.83334 8.5 5.06001 8.5 5.33334V8.66668C8.5 8.94001 8.27333 9.16668 8 9.16668Z",
    fill: "#757575"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 1.83334H6C5.72667 1.83334 5.5 1.60668 5.5 1.33334C5.5 1.06001 5.72667 0.833344 6 0.833344H10C10.2733 0.833344 10.5 1.06001 10.5 1.33334C10.5 1.60668 10.2733 1.83334 10 1.83334Z",
    fill: "#757575"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcontimemanager, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icontimemanager.9dbc39fe.svg";
export { ForwardRef as ReactComponent };